/**
 * The shell every signed-in screen renders inside: one rail, one content area.
 *
 * This replaces DashboardLayout, WreLayout and AdminLayout — three shells that
 * disagreed about whether there was a sidebar, what colour the chrome was, and
 * where "back to the system" went. Admin is a route in here now, not a separate
 * world with its own purple header.
 */
import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import Rail, { TopBar } from "@/components/Rail";
import { LiveProvider } from "@/lib/live";
import { ToastProvider } from "@/components/ui/Feedback";

export default function AppLayout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    // LiveProvider sits inside the shell, not at the app root: the one
    // EventSource should exist only while a signed-in screen is mounted, so
    // /login and /privacy never open a stream they cannot authenticate.
    <LiveProvider>
      <ToastProvider>
        <div className="app">
          <TopBar onOpen={() => setNavOpen(true)} />
          {navOpen && <button className="scrim" aria-label="סגירת תפריט" onClick={() => setNavOpen(false)} />}
          <Rail open={navOpen} onClose={() => setNavOpen(false)} />
          <main className="app-main">
            <Suspense fallback={<div className="state" aria-busy="true" />}>
              <Outlet />
            </Suspense>
          </main>
        </div>
      </ToastProvider>
    </LiveProvider>
  );
}
